(function () {

  // ── Colour helpers ────────────────────────────────────────────────────────

  const COLORS = {
    cafe_fixed:  '#00af9f',
    cafe_mobile: '#ffcc43',
    store:       '#f26858',
  };

  function getColor(d) {
    if (d.cat === 'store')   return COLORS.store;
    if (d.type === 'mobile') return COLORS.cafe_mobile;
    return COLORS.cafe_fixed;
  }

  function tagLabel(d) {
    if (d.cat === 'store')   return 'Store';
    if (d.type === 'mobile') return 'Cafe · mobile';
    return 'Cafe';
  }

  function tagClass(d) {
    if (d.cat === 'store')   return 'tag-store';
    if (d.type === 'mobile') return 'tag-mobile';
    return 'tag-cafe';
  }

  function hasCoords(d) {
    return typeof d.lat === 'number' && typeof d.lng === 'number';
  }

  // ── Marker icon ───────────────────────────────────────────────────────────

  function makeIcon(d, active) {
    const c   = getColor(d);
    const size = active ? 18 : 13;
    const border = active ? '3px solid white' : '2.5px solid white';
    const shadow = active
      ? '0 2px 8px rgba(0,0,0,0.45)'
      : '0 1px 4px rgba(0,0,0,0.25)';

    const isStore = d.cat === 'store';
    const shape = isStore
      ? `<span style="
            display:block;width:${size}px;height:${size}px;
            border-radius:3px;background:${c};
            border:${border};box-shadow:${shadow};
            transform:rotate(45deg);"></span>`
      : `<span style="
            display:block;width:${size}px;height:${size}px;
            border-radius:50%;background:${c};
            border:${border};box-shadow:${shadow};"></span>`;

    return L.divIcon({
      className: '',
      html: shape,
      iconSize:    [size, size],
      iconAnchor:  [size / 2, size / 2],
      popupAnchor: [0, -size - 2],
    });
  }

  // ── Popup HTML ────────────────────────────────────────────────────────────

  function makePopup(d) {
    const link = d.url
      ? `<a class="map-popup__link ${d.cat}" href="${d.url}" target="_blank" rel="noopener">Visit website ↗</a>`
      : '';
    return `<div class="map-popup">
      <p class="map-popup__name">${d.name}</p>
      <p class="map-popup__address">${d.address}</p>
      ${link}
      <span class="map-popup__tag ${tagClass(d)}">${tagLabel(d)}</span>
    </div>`;
  }

  // ── Sidebar card HTML ─────────────────────────────────────────────────────

  function makeCard(d, idx) {
    const link = d.url
      ? `<a class="sidebar-card__link" href="${d.url}" target="_blank" rel="noopener"
            onclick="event.stopPropagation()">Visit website ↗</a>`
      : '';
    return `<div
        class="sidebar-card"
        id="sidebar-card-${idx}"
        data-idx="${idx}"
        onclick="window._locationMapSelectIdx(${idx})">
      <div class="sidebar-card__dot" style="background:${getColor(d)};
        ${d.cat === 'store' ? 'border-radius:2px;transform:rotate(45deg);' : 'border-radius:50%;'}">
      </div>
      <div class="sidebar-card__body">
        <p class="sidebar-card__name">${d.name}</p>
        <p class="sidebar-card__address">${d.address}</p>
        ${link}
        <span class="sidebar-card__tag ${tagClass(d)}">${tagLabel(d)}</span>
      </div>
    </div>`;
  }

  // ── Main init ─────────────────────────────────────────────────────────────

  function initMap() {
    const data = window.locationData || [];
    if (!data.length) { console.warn('Location map: no data'); return; }
    if (typeof L === 'undefined') { console.warn('Location map: Leaflet not loaded'); return; }

    const sidebar = document.getElementById('locationSidebar');

    // Build sidebar cards
    sidebar.innerHTML = data.map((d, i) => makeCard(d, i)).join('');

    // Build map
    const map = L.map('locationMap', { scrollWheelZoom: false })
      .setView([38, -90], 4);

    // Sync sidebar height to map height (desktop only — mobile overrides via CSS)
    document.getElementById('locationSidebar').style.maxHeight =
      document.getElementById('locationMap').offsetHeight + 'px';

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map);

    setTimeout(() => map.invalidateSize(), 200);
    window.addEventListener('resize', () => map.invalidateSize());

    // Create markers — skip any location missing valid lat/lng so it doesn't
    // throw and break marker creation for everything after it. Those
    // locations still get a sidebar card, just no pin / no fly-to.
    let activeIdx = null;

    const markers = data.map((d, i) => {
      if (!hasCoords(d)) {
        if (window.console) {
          console.warn(`Location map: "${d.name}" has no lat/lng — showing in list only, no pin.`);
        }
        return null;
      }

      const m = L.marker([d.lat, d.lng], { icon: makeIcon(d, false) })
        .bindPopup(makePopup(d), { maxWidth: 260 })
        .addTo(map);

      // Marker click → select
      m.on('click', () => selectIdx(i));

      m._locIdx = i;
      return m;
    });

    // ── Helper: is the sidebar currently a horizontal carousel? ────────────

    function isCarousel() {
      return window.matchMedia('(max-width: 680px)').matches;
    }

    // ── Select a location (from sidebar or marker) ────────────────────────

    function selectIdx(idx) {
      const d = data[idx];

      // Deactivate all cards + markers first (prevents multi-highlight bug)
      document.querySelectorAll('.sidebar-card').forEach(c => c.classList.remove('is-active'));
      if (activeIdx !== null && markers[activeIdx]) {
        markers[activeIdx].setIcon(makeIcon(data[activeIdx], false));
      }

      activeIdx = idx;

      // Activate marker — enlarge + open popup (only if this location has one)
      if (markers[idx]) {
        markers[idx].setIcon(makeIcon(d, true));
        map.flyTo([d.lat, d.lng], 14, { animate: true, duration: 0.8 });
        markers[idx].openPopup();
      }

      // Activate sidebar card + scroll into view
      const card = document.getElementById(`sidebar-card-${idx}`);
      if (card) {
        card.classList.add('is-active');

        if (isCarousel()) {
          // Horizontal scroll: center the card in the carousel
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          // Vertical sidebar: scroll within the list
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    // Expose to inline onclick and filter function
    window._locationMapSelectIdx = selectIdx;

    // Deselect when map popup closes
    map.on('popupclose', () => {
      if (activeIdx !== null) {
        if (markers[activeIdx]) {
          markers[activeIdx].setIcon(makeIcon(data[activeIdx], false));
        }
        const card = document.getElementById(`sidebar-card-${activeIdx}`);
        if (card) card.classList.remove('is-active');
        activeIdx = null;
      }
    });

    // ── Filter ────────────────────────────────────────────────────────────

    window.filterLocations = function (btn) {
      // Deselect active
      if (activeIdx !== null) {
        if (markers[activeIdx]) {
          markers[activeIdx].setIcon(makeIcon(data[activeIdx], false));
        }
        const card = document.getElementById(`sidebar-card-${activeIdx}`);
        if (card) card.classList.remove('is-active');
        activeIdx = null;
        map.closePopup();
      }

      // Update button styles
      document.querySelectorAll('.map-filter-btn').forEach(b =>
        b.classList.remove('active-all', 'active-cafe', 'active-store', 'active-mobile')
      );
      const cls = { all: 'active-all', cafe: 'active-cafe', store: 'active-store', mobile: 'active-mobile' };
      btn.classList.add(cls[btn.dataset.type]);

      const t = btn.dataset.type;
      let count = 0;

      data.forEach((d, i) => {
        const show =
          t === 'all' ||
          (t === 'cafe'   && d.cat === 'cafe'  && d.type !== 'mobile') ||
          (t === 'store'  && d.cat === 'store') ||
          (t === 'mobile' && d.type === 'mobile');

        if (show) count++;

        // Map layer (only locations that have a marker)
        const m = markers[i];
        if (m) {
          if (show) m.addTo(map);
          else map.removeLayer(m);
        }

        // Sidebar / carousel card
        const card = document.getElementById(`sidebar-card-${i}`);
        if (card) card.style.display = show ? '' : 'none';
      });

      document.getElementById('locationCount').textContent =
        count + ' location' + (count !== 1 ? 's' : '');

      // Scroll sidebar/carousel back to start
      const sidebarEl = document.getElementById('locationSidebar');
      if (sidebarEl) {
        sidebarEl.scrollTop = 0;
        sidebarEl.scrollLeft = 0;
      }
    };

    // Set the initial count on load to match the actual data length,
    // rather than relying on a hardcoded number in the Liquid markup.
    document.getElementById('locationCount').textContent =
      data.length + ' location' + (data.length !== 1 ? 's' : '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMap);
  } else {
    initMap();
  }

})();